import React from "react";
import { Box } from "@mui/material";
import { BlogDetailsStyles } from "../Styles";
import BackgroundImg from "../../assets/Banner/Blogs/BlogBanner.png";

const BlogHeroCardOne = () => {
  return (
    <Box sx={BlogDetailsStyles.BlogParentCard}>
      <Box
        sx={{
          position: "relative",
          // height: "90vh",
          backgroundImage: `url(${BackgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat", // prevents tiling
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",

          //
          width: "100%",
          // height: { xs: "200px", sm: "300px", md: "350px", lg: "350px" }, // Responsive heights
          height: { xs: "200px", sm: "300px", md: "400px", lg: "400px" }, // Responsive heights
        }}
      />
    </Box>
  );
};

export default BlogHeroCardOne;
